import { create } from 'zustand';

interface AssignClientState {
    clientAssigned: boolean;
    setClientAssigned: (open: boolean) => void;
}

// Create the Zustand store with types
const useStore = create<AssignClientState>((set) => ({
    clientAssigned: false,
    setClientAssigned: (open: boolean) => set({ clientAssigned: open }),
}));

export default useStore;
